// extracted by mini-css-extract-plugin
export default {"card":"styles_card__YWEn7","cardImage":"styles_cardImage__EU9l+","cardText":"styles_cardText__FOqUs"};